import { useContext, useEffect, useState } from "react";
import { AppContext } from "../context";
import { getAuditByTenant } from "../services/audit/audit";

type UseType = "DATA";

export const useAudit = (type: UseType) => {
  const { 
    toast, 
    appState: { tenantId, selectedTenantId } 
  } = useContext(AppContext);
  const [data, setData] = useState<any | null>(null);
  const [reload, setReload] = useState<number>(0);

  const reloadFn = () => {
    setData(null);
    setReload((prev) => prev + 1);
  };

  useEffect(() => {
    if (type) {
      (async function () {
        await Promise.resolve(getAuditByTenant(selectedTenantId || tenantId))
          .then((response) => {
            setData(response?.data);
          })
          .catch((error) => {
            setData([]);
          });
      })();
    }
  }, [toast, reload, type, tenantId, selectedTenantId]);

  return {
    data,
    reloadFn,
  };
};
